<template>
  <div
    :class="`cart_item_bundles ${styleType}`"
    v-if="appliedBundles.length > 0"
  >
    <template v-if="styleType === 'legacy'">
      <span>{{ t('product_bundles.cart_message.header') }}</span>
      <div class="rule_details">
        <div class="rule_prices" v-if="expanded">
          <div
            class="rule_price save_price"
            v-html="t('product_bundles.cart_message.save_price', { params: [ bundleSavePriceWithSign ] })"
          ></div>
          <div
            class="rule_price previous_price"
            v-html="t('product_bundles.cart_message.previous_price', { params: [ bundlePreviousPriceWithSign ] })"
          ></div>
        </div>
        <ul>
          <li v-for="bundle in appliedBundles">
            <span
              class="rule_explanation"
              v-html="t(
                'product_bundles.cart_message.rule_explanation',
                { params: [ Math.trunc(bundle.resolvedPricingDiscount), bundle.mui.cart_message ] }
                )"
            ></span>
            <span
              class="rule_usage"
              v-html="t(
                'product_bundles.cart_message.rule_usage',
                { params: [ bundle.instances ] }
                )"
            ></span>
          </li>
        </ul>
      </div>
    </template>
    <div class="rule_details" v-if="styleType === 'smart'">
      <span class="rule_explanation">
        <span :class="`pb_rule_${getModernRuleType}_discount`">{{ getModernRuleDiscount }}</span>
        <span :class="`pb_rule_${getModernRuleType}_message`">{{ getModernRuleExplainMessage }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvCartProductBundleDisplay',
  props: {
    cartProduct: {
      type: Object
    },
    productData: {
      type: Object
    },
    expanded: {
      type: Boolean,
      default: false
    },
    styleType: {
      type: String,
      default: 'smart'
    }
  },
  computed: {
    ...mapGetters(['getSelectedCurrency']),
    bundleSavePriceWithSign() {
      return this.asCurrency(this.productData.productBundleSavePrice)
    },
    bundlePreviousPriceWithSign() {
      return this.asCurrency(this.productData.productBundlePreviousPrice)
    },
    appliedBundles() {
      if (!this.cartProduct.options || !this.cartProduct.options.appliedBundles) {
        return []
      }
      return this.cartProduct.options.appliedBundles
    },
    getModernRuleDiscount() {
      const totalDiscount = 1 - (this.productData.productFinalPrice / this.productData.productBundlePreviousPrice)
      return `-${(totalDiscount * 100).toFixed(0)}%`
    },
    getModernRuleExplainMessage() {
      if (this.getModernRuleType === 'generic') {
        return this.t('product_bundles.cart_message.smart.generic')
      }

      return this.t(
        'product_bundles.cart_message.smart.pieces',
        { params: [ this.appliedBundles[0].resolvedPricingMatchQuantity ] }
      )
    },
    getModernRuleType() {
      if (this.appliedBundles.length > 1) {
        return 'generic'
      }
      if (!this.appliedBundles[0].matchedCriterionHasExactlyOneProduct) {
        return 'generic'
      }
      return 'pieces'
    }
  },
  methods: {
    asCurrency(price) {
      return (price * this.getSelectedCurrency.rate).toFixed(2) + this.getSelectedCurrency.symbol
    }
  }
}
</script>

<style lang="scss">
.cart_item_bundles.smart {
  .pb_rule_name {
    display: inline-block;
    padding-inline: 5px;
  }
  .pb_rule_discount {
    display: inline-block;
    padding-inline: 5px;
  }
  .rule_explanation {
    display: flex;
    gap: 0;
    padding: 0;
    width: max-content;
    margin: 0 0 0.25rem 0;
    border-radius: 0.25rem;
    overflow: hidden;
    & > * {
      flex-basis: max-content;
      font-size: 0.75em;
      padding: 0.15rem 0.5rem;
      margin: 0;
    }
  }
}
.cart_item_bundles.legacy {
  .pb_rule_discount {
    font-size: 1.3em;
    line-height: 1em;
  }

  li {
    .rule_details {
      padding-left: 0.75rem;
    }
  }
}
.cart_item_bundles {
  text-align: left;
  --primary: #1a1e21;
  --secondary: #212529;
  --font-size-small: 0.8em;

  ul {
    list-style-type: none;
    padding: 0;
    font-size: var(--font-size-small);
  }

  li {
    display: flex;
    flex-flow: column;
    vertical-align: middle;
    padding: 0.25rem 0;
  }

  .rule_explanation {
    color: var(--primary);

    .pb_rule_discount {
      font-weight: bold;
    }

    .pb_rule_name {
      font-weight: bold;
    }

    .pb_rule_plus_pieces {
      background-color: #BCF8E7;
    }

    .pb_rule_pieces_discount {
      background-color: #D98DFF;
    }

    .pb_rule_pieces_message {
      background-color: #F4DDFF;
    }

    .pb_rule_generic_discount {
      background-color: #21E9AE;
    }

    .pb_rule_generic_message {
      background-color: #BCF8E7;
    }
  }

  .rule_usage {
    color: var(--secondary);

    .pb_rule_usage_value {
      font-weight: bold;
    }
  }

  .rule_prices {
    font-size: var(--font-size-small);

    .pb_rule_save_price,
    .pb_rule_previous_price {
      font-weight: bold;
    }
  }
}
</style>
